'use client';

import type { ComponentProps } from 'react';
import { cn } from '../ui/utils';
import {
  Tooltip as BadgeTooltip,
  TooltipTrigger as BadgeTooltipTrigger,
  TooltipContent as BaseTooltipContent,
} from '../ui/tooltip';

function BadgeTooltipContent({
  className,
  children,
  sideOffset = 12,
  ...props
}: ComponentProps<typeof BaseTooltipContent>) {
  return (
    <BaseTooltipContent
      className={cn(
        'tw-z-[10000] tw-w-fit tw-max-w-xs tw-overflow-visible tw-rounded-[var(--radius)] tw-bg-popover tw-px-[var(--spacing-3)] tw-py-[var(--spacing-2)] tw-text-center tw-leading-snug tw-text-popover-foreground tw-shadow-[var(--elevation-lg)]',
        className,
      )}
      sideOffset={sideOffset}
      {...props}
    >
      {children}
    </BaseTooltipContent>
  );
}

export { BadgeTooltip, BadgeTooltipTrigger, BadgeTooltipContent };
